/**
 * HeroData.js
 * 
 * This module provides data for all Mobile Legends heroes.
 * For a production application, this would be fetched from an API.
 */

// Hero data with Mobile Legends heroes
export const HeroData = {
  aamon: {
    id: 'aamon',
    name: 'Aamon',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/d/d4/Hero871-icon.png',
    attributes: { primary: 'assassin', damage: 9, durability: 4, difficulty: 8 }
  },
  akai: {
    id: 'akai',
    name: 'Akai',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/9/9e/Hero161-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 9, difficulty: 5 }
  },
  aldous: {
    id: 'aldous',
    name: 'Aldous',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/7/79/Hero521-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 7, difficulty: 6 }
  },
  alice: {
    id: 'alice',
    name: 'Alice',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/cd/Hero071-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 6, difficulty: 5 }
  },
  alpha: {
    id: 'alpha',
    name: 'Alpha',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/8/8b/Hero141-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  alucard: {
    id: 'alucard',
    name: 'Alucard',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f1/Hero051-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 6, difficulty: 4 }
  },
  angela: {
    id: 'angela',
    name: 'Angela',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/0/01/Hero231-icon.png',
    attributes: { primary: 'support', damage: 5, durability: 5, difficulty: 7 }
  },
  argus: {
    id: 'argus',
    name: 'Argus',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/5/58/Hero481-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 7, difficulty: 5 }
  },
  arlott: {
    id: 'arlott',
    name: 'Arlott',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/a/ac/Hero1221-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 7 }
  },
  atlas: {
    id: 'atlas',
    name: 'Atlas',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/6/6b/Hero611-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 9, difficulty: 7 }
  },
  aulus: {
    id: 'aulus',
    name: 'Aulus',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/5/5b/Hero631-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 7, difficulty: 5 }
  },
  aurora: {
    id: 'aurora',
    name: 'Aurora',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/d/dc/Hero211-icon.png',
    attributes: { primary: 'mage', damage: 9, durability: 4, difficulty: 6 }
  },
  badang: {
    id: 'badang',
    name: 'Badang',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/7/7d/Hero551-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  balmond: {
    id: 'balmond',
    name: 'Balmond',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/8/8b/Hero031-icon.png',
    attributes: { primary: 'fighter', damage: 6, durability: 8, difficulty: 3 }
  },
  bane: {
    id: 'bane',
    name: 'Bane',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/6/64/Hero041-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 4 }
  },
  barats: {
    id: 'barats',
    name: 'Barats',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/2/27/Hero651-icon.png',
    attributes: { primary: 'tank', damage: 6, durability: 9, difficulty: 6 }
  },
  baxia: {
    id: 'baxia',
    name: 'Baxia',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/1/18/Hero581-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 9, difficulty: 5 }
  },
  beatrix: {
    id: 'beatrix',
    name: 'Beatrix',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/3/3e/Hero681-icon.png',
    attributes: { primary: 'marksman', damage: 9, durability: 4, difficulty: 8 }
  },
  belerick: {
    id: 'belerick',
    name: 'Belerick',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/0/03/Hero531-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 10, difficulty: 4 }
  },
  benedetta: {
    id: 'benedetta',
    name: 'Benedetta',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/1/1a/Hero661-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 7 }
  },
  brody: {
    id: 'brody',
    name: 'Brody',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/8/89/Hero641-icon.png',
    attributes: { primary: 'marksman', damage: 9, durability: 4, difficulty: 6 }
  },
  bruno: {
    id: 'bruno',
    name: 'Bruno',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/6/65/Hero151-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 5 }
  },
  carmilla: {
    id: 'carmilla',
    name: 'Carmilla',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c8/Hero241-icon.png',
    attributes: { primary: 'support', damage: 5, durability: 6, difficulty: 6 }
  },
  cecilion: {
    id: 'cecilion',
    name: 'Cecilion',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c1/Hero081-icon.png',
    attributes: { primary: 'mage', damage: 9, durability: 4, difficulty: 7 }
  },
  change: {
    id: 'change',
    name: "Chang'e",
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c9/Hero091-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 5 }
  },
  chip: {
    id: 'chip',
    name: 'Chip',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c4/Hero061-icon.png',
    attributes: { primary: 'mage', damage: 7, durability: 5, difficulty: 6 }
  },
  chou: {
    id: 'chou',
    name: 'Chou',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c7/Hero101-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 7 }
  },
  cici: {
    id: 'cici',
    name: 'Cici',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c2/Hero021-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 6 }
  },
  claude: {
    id: 'claude',
    name: 'Claude',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c6/Hero111-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 5, difficulty: 6 }
  },
  clint: {
    id: 'clint',
    name: 'Clint',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/c0/Hero011-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 5 }
  },
  cyclops: {
    id: 'cyclops',
    name: 'Cyclops',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/c/cf/Hero131-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 5, difficulty: 4 }
  },
  diggie: {
    id: 'diggie',
    name: 'Diggie',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/d/d1/Hero171-icon.png',
    attributes: { primary: 'support', damage: 4, durability: 6, difficulty: 6 }
  },
  dyrroth: {
    id: 'dyrroth',
    name: 'Dyrroth',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/d/d3/Hero181-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 6, difficulty: 6 }
  },
  edith: {
    id: 'edith',
    name: 'Edith',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/e/e1/Hero191-icon.png',
    attributes: { primary: 'tank', damage: 6, durability: 8, difficulty: 7 }
  },
  esmeralda: {
    id: 'esmeralda',
    name: 'Esmeralda',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/e/e3/Hero201-icon.png',
    attributes: { primary: 'mage', damage: 7, durability: 7, difficulty: 6 }
  },
  estes: {
    id: 'estes',
    name: 'Estes',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/e/e7/Hero211-icon.png',
    attributes: { primary: 'support', damage: 3, durability: 6, difficulty: 4 }
  },
  eudora: {
    id: 'eudora',
    name: 'Eudora',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/e/e9/Hero221-icon.png',
    attributes: { primary: 'mage', damage: 9, durability: 3, difficulty: 4 }
  },
  fanny: {
    id: 'fanny',
    name: 'Fanny',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f2/Hero231-icon.png',
    attributes: { primary: 'assassin', damage: 9, durability: 4, difficulty: 10 }
  },
  faramis: {
    id: 'faramis',
    name: 'Faramis',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f0/Hero241-icon.png',
    attributes: { primary: 'support', damage: 6, durability: 5, difficulty: 7 }
  },
  floryn: {
    id: 'floryn',
    name: 'Floryn',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f8/Hero251-icon.png',
    attributes: { primary: 'support', damage: 4, durability: 5, difficulty: 5 }
  },
  franco: {
    id: 'franco',
    name: 'Franco',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f5/Hero261-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 9, difficulty: 6 }
  },
  fredrinn: {
    id: 'fredrinn',
    name: 'Fredrinn',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f1/Hero271-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  freya: {
    id: 'freya',
    name: 'Freya',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/f/f3/Hero281-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 5 }
  },
  gatotkaca: {
    id: 'gatotkaca',
    name: 'Gatotkaca',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/g1/Hero291-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 9, difficulty: 5 }
  },
  gloo: {
    id: 'gloo',
    name: 'Gloo',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/g3/Hero301-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 8, difficulty: 7 }
  },
  gord: {
    id: 'gord',
    name: 'Gord',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/g5/Hero311-icon.png',
    attributes: { primary: 'mage', damage: 9, durability: 3, difficulty: 5 }
  },
  granger: {
    id: 'granger',
    name: 'Granger',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/g7/Hero321-icon.png',
    attributes: { primary: 'marksman', damage: 9, durability: 4, difficulty: 6 }
  },
  grock: {
    id: 'grock',
    name: 'Grock',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/g9/Hero331-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 9, difficulty: 5 }
  },
  guinevere: {
    id: 'guinevere',
    name: 'Guinevere',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/gb/Hero341-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 6, difficulty: 7 }
  },
  gusion: {
    id: 'gusion',
    name: 'Gusion',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/g/gd/Hero351-icon.png',
    attributes: { primary: 'assassin', damage: 9, durability: 4, difficulty: 8 }
  },
  hanabi: {
    id: 'hanabi',
    name: 'Hanabi',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/h1/Hero361-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 5 }
  },
  hanzo: {
    id: 'hanzo',
    name: 'Hanzo',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/h3/Hero371-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 8 }
  },
  harith: {
    id: 'harith',
    name: 'Harith',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/h5/Hero381-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 5, difficulty: 7 }
  },
  harley: {
    id: 'harley',
    name: 'Harley',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/h7/Hero391-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 6 }
  },
  hayabusa: {
    id: 'hayabusa',
    name: 'Hayabusa',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/h9/Hero401-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 7 }
  },
  helcurt: {
    id: 'helcurt',
    name: 'Helcurt',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/hb/Hero411-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 6 }
  },
  hilda: {
    id: 'hilda',
    name: 'Hilda',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/hd/Hero421-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 8, difficulty: 4 }
  },
  hylos: {
    id: 'hylos',
    name: 'Hylos',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/h/hf/Hero431-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 10, difficulty: 4 }
  },
  irithel: {
    id: 'irithel',
    name: 'Irithel',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/i/i1/Hero441-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 6 }
  },
  ixia: {
    id: 'ixia',
    name: 'Ixia',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/i/i3/Hero451-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  jawhead: {
    id: 'jawhead',
    name: 'Jawhead',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/j/j1/Hero461-icon.png',
    attributes: { primary: 'fighter', damage: 6, durability: 7, difficulty: 6 }
  },
  johnson: {
    id: 'johnson',
    name: 'Johnson',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/j/j3/Hero471-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 9, difficulty: 7 }
  },
  joy: {
    id: 'joy',
    name: 'Joy',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/j/j5/Hero481-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 7 }
  },
  julian: {
    id: 'julian',
    name: 'Julian',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/j/j7/Hero491-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 6, difficulty: 8 }
  },
  kadita: {
    id: 'kadita',
    name: 'Kadita',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/k1/Hero501-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 5, difficulty: 6 }
  },
  kagura: {
    id: 'kagura',
    name: 'Kagura',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/k3/Hero511-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 8 }
  },
  kaja: {
    id: 'kaja',
    name: 'Kaja',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/k5/Hero521-icon.png',
    attributes: { primary: 'support', damage: 6, durability: 6, difficulty: 6 }
  },
  karina: {
    id: 'karina',
    name: 'Karina',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/k7/Hero531-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 5 }
  },
  karrie: {
    id: 'karrie',
    name: 'Karrie',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/k9/Hero541-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 6 }
  },
  khaleed: {
    id: 'khaleed',
    name: 'Khaleed',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/kb/Hero551-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 6 }
  },
  khufra: {
    id: 'khufra',
    name: 'Khufra',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/kd/Hero561-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 8, difficulty: 7 }
  },
  kimmy: {
    id: 'kimmy',
    name: 'Kimmy',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/kf/Hero571-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 5, difficulty: 7 }
  },
  lancelot: {
    id: 'lancelot',
    name: 'Lancelot',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/l1/Hero581-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 7 }
  },
  lapu_lapu: {
    id: 'lapu_lapu',
    name: 'Lapu-Lapu',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/l3/Hero591-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  layla: {
    id: 'layla',
    name: 'Layla',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/l5/Hero601-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 3, difficulty: 3 }
  },
  leomord: {
    id: 'leomord',
    name: 'Leomord',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/l7/Hero611-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  lesley: {
    id: 'lesley',
    name: 'Lesley',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/l9/Hero621-icon.png',
    attributes: { primary: 'marksman', damage: 9, durability: 3, difficulty: 6 }
  },
  ling: {
    id: 'ling',
    name: 'Ling',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/lb/Hero631-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 8 }
  },
  lolita: {
    id: 'lolita',
    name: 'Lolita',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/ld/Hero641-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 8, difficulty: 5 }
  },
  lunox: {
    id: 'lunox',
    name: 'Lunox',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/lf/Hero651-icon.png',
    attributes: { primary: 'mage', damage: 9, durability: 4, difficulty: 8 }
  },
  luo_yi: {
    id: 'luo_yi',
    name: 'Luo Yi',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/lh/Hero661-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  lylia: {
    id: 'lylia',
    name: 'Lylia',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/lj/Hero671-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 5, difficulty: 6 }
  },
  martis: {
    id: 'martis',
    name: 'Martis',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/m1/Hero681-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  masha: {
    id: 'masha',
    name: 'Masha',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/m3/Hero691-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 5 }
  },
  mathilda: {
    id: 'mathilda',
    name: 'Mathilda',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/m5/Hero701-icon.png',
    attributes: { primary: 'support', damage: 5, durability: 6, difficulty: 7 }
  },
  melissa: {
    id: 'melissa',
    name: 'Melissa',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/m7/Hero711-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  minotaur: {
    id: 'minotaur',
    name: 'Minotaur',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/m9/Hero721-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 8, difficulty: 5 }
  },
  minsitthar: {
    id: 'minsitthar',
    name: 'Minsitthar',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/mb/Hero731-icon.png',
    attributes: { primary: 'fighter', damage: 6, durability: 7, difficulty: 6 }
  },
  miya: {
    id: 'miya',
    name: 'Miya',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/md/Hero741-icon.png',
    attributes: { primary: 'marksman', damage: 7, durability: 4, difficulty: 4 }
  },
  moskov: {
    id: 'moskov',
    name: 'Moskov',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/m/mf/Hero751-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 6 }
  },
  nana: {
    id: 'nana',
    name: 'Nana',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/n/n1/Hero761-icon.png',
    attributes: { primary: 'mage', damage: 7, durability: 4, difficulty: 4 }
  },
  natalia: {
    id: 'natalia',
    name: 'Natalia',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/n/n3/Hero771-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 7 }
  },
  natan: {
    id: 'natan',
    name: 'Natan',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/n/n5/Hero781-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  nolan: {
    id: 'nolan',
    name: 'Nolan',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/n/n7/Hero791-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 6 }
  },
  novaria: {
    id: 'novaria',
    name: 'Novaria',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/n/n9/Hero801-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  obsidia: {
    id: 'obsidia',
    name: 'Obsidia',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/character-beats-talent.firebasestorage.app/o/public%2Fimages%2FObsidia.png?alt=media',
    attributes: { primary: 'marksman', damage: 9, durability: 4, difficulty: 7 }
  },
  odette: {
    id: 'odette',
    name: 'Odette',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/o/o1/Hero811-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 5 }
  },
  paquito: {
    id: 'paquito',
    name: 'Paquito',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/p/p1/Hero821-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 7 }
  },
  pharsa: {
    id: 'pharsa',
    name: 'Pharsa',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/p/p3/Hero831-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 6 }
  },
  phoveus: {
    id: 'phoveus',
    name: 'Phoveus',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/p/p5/Hero841-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  popol_and_kupa: {
    id: 'popol_and_kupa',
    name: 'Popol and Kupa',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/p/p7/Hero851-icon.png',
    attributes: { primary: 'marksman', damage: 7, durability: 5, difficulty: 7 }
  },
  rafaela: {
    id: 'rafaela',
    name: 'Rafaela',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/r/r1/Hero861-icon.png',
    attributes: { primary: 'support', damage: 4, durability: 5, difficulty: 4 }
  },
  roger: {
    id: 'roger',
    name: 'Roger',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/r/r3/Hero871-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 6 }
  },
  ruby: {
    id: 'ruby',
    name: 'Ruby',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/r/r5/Hero881-icon.png',
    attributes: { primary: 'fighter', damage: 6, durability: 7, difficulty: 6 }
  },
  saber: {
    id: 'saber',
    name: 'Saber',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/s/s1/Hero891-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 5, difficulty: 5 }
  },
  selena: {
    id: 'selena',
    name: 'Selena',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/s/s3/Hero901-icon.png',
    attributes: { primary: 'assassin', damage: 8, durability: 4, difficulty: 8 }
  },
  silvanna: {
    id: 'silvanna',
    name: 'Silvanna',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/s/s5/Hero911-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 6 }
  },
  sun: {
    id: 'sun',
    name: 'Sun',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/s/s7/Hero921-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 5 }
  },
  terizla: {
    id: 'terizla',
    name: 'Terizla',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/t/t1/Hero931-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  thamuz: {
    id: 'thamuz',
    name: 'Thamuz',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/t/t3/Hero941-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  tigreal: {
    id: 'tigreal',
    name: 'Tigreal',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/t/t5/Hero951-icon.png',
    attributes: { primary: 'tank', damage: 4, durability: 9, difficulty: 4 }
  },
  uranus: {
    id: 'uranus',
    name: 'Uranus',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/u/u1/Hero961-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 9, difficulty: 5 }
  },
  vale: {
    id: 'vale',
    name: 'Vale',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/v/v1/Hero971-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 6 }
  },
  valentina: {
    id: 'valentina',
    name: 'Valentina',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/v/v3/Hero981-icon.png',
    attributes: { primary: 'mage', damage: 7, durability: 5, difficulty: 8 }
  },
  valir: {
    id: 'valir',
    name: 'Valir',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/v/v5/Hero991-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 6 }
  },
  vexana: {
    id: 'vexana',
    name: 'Vexana',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/v/v7/Hero1001-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  wanwan: {
    id: 'wanwan',
    name: 'Wanwan',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/w/w1/Hero1011-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  x_borg: {
    id: 'x_borg',
    name: 'X.Borg',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/x/x1/Hero1021-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  xavier: {
    id: 'xavier',
    name: 'Xavier',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/x/x3/Hero1031-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  yi_sun_shin: {
    id: 'yi_sun_shin',
    name: 'Yi Sun-shin',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/y/y1/Hero1041-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  yin: {
    id: 'yin',
    name: 'Yin',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/y/y3/Hero1051-icon.png',
    attributes: { primary: 'fighter', damage: 8, durability: 6, difficulty: 7 }
  },
  yu_zhong: {
    id: 'yu_zhong',
    name: 'Yu Zhong',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/y/y5/Hero1061-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 7, difficulty: 6 }
  },
  yve: {
    id: 'yve',
    name: 'Yve',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/y/y7/Hero1071-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  zhask: {
    id: 'zhask',
    name: 'Zhask',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/z/z1/Hero1081-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  zhuxin: {
    id: 'zhuxin',
    name: 'Zhuxin',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/z/z3/Hero1091-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 6 }
  },
  zilong: {
    id: 'zilong',
    name: 'Zilong',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/z/z5/Hero1101-icon.png',
    attributes: { primary: 'fighter', damage: 7, durability: 6, difficulty: 4 }
  },
  suyou: {
    id: 'suyou',
    name: 'Suyou',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/s/s9/Hero1111-icon.png',
    attributes: { primary: 'tank', damage: 5, durability: 8, difficulty: 6 }
  },
  lukas: {
    id: 'lukas',
    name: 'Lukas',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/l/ll/Hero1121-icon.png',
    attributes: { primary: 'marksman', damage: 8, durability: 4, difficulty: 7 }
  },
  kalea: {
    id: 'kalea',
    name: 'Kalea',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/k/kl/Hero1131-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 7 }
  },
  zetian: {
    id: 'zetian',
    name: 'Zetian',
    imageUrl: 'https://static.wikia.nocookie.net/mobile-legends/images/z/zt/Hero1141-icon.png',
    attributes: { primary: 'mage', damage: 8, durability: 4, difficulty: 8 }
  },
  marcel: {
    id: 'marcel',
    name: 'Marcel',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/character-beats-talent.firebasestorage.app/o/public%2Fimages%2FMarcel.webp?alt=media',
    attributes: { primary: 'support', damage: 5, durability: 5, difficulty: 6 }
  },
  sora: {
    id: 'sora',
    name: 'Sora',
    imageUrl: 'https://akmweb.youngjoygame.com/web/svnres/img/mlbb/homepage_2_1_40/100_4749a1f7fe99cbedfc5ef23fc1287d6c.png',
    attributes: { primary: 'assassin', damage: 9, durability: 4, difficulty: 7 }
  }
};

const heroData = { 
  HeroData,
  getHeroById: (id) => HeroData[id.toLowerCase()] || null,
  getHeroByName: (name) => {
    const heroId = Object.keys(HeroData).find(key => 
      HeroData[key].name.toLowerCase() === name.toLowerCase()
    );
    return heroId ? HeroData[heroId] : null;
  }
}; 

export default heroData; 